// song-header — renders song name + key/BPM/timeSignature meta line.
// Uses real desktop class names (.rh-songhead / .sh-title / .sh-meta).
// CSS extracted to app/renderer/ui/rehearsal/song-header.css (consumed via @desktop-css alias).

import type { ShareManifest } from '@bandway/share-types';

export interface SongHeaderHandle {
  update: (manifest: ShareManifest) => void;
  unmount: () => void;
}

export function mountSongHeader(
  host: Element,
  manifest: ShareManifest,
): SongHeaderHandle {
  host.textContent = '';
  const root = document.createElement('div');
  root.className = 'rh-songhead';

  const name = document.createElement('div');
  name.className = 'sh-title';
  root.appendChild(name);

  const meta = document.createElement('div');
  meta.className = 'sh-meta';
  root.appendChild(meta);

  host.appendChild(root);

  const render = (m: ShareManifest): void => {
    name.textContent = m.song.name;
    meta.textContent = `${m.song.key} · ${m.song.bpm} BPM · ${m.song.timeSignature}`;
  };
  render(manifest);

  return {
    update: render,
    unmount: () => {
      host.textContent = '';
    },
  };
}
